const WarrantyTerm = () => {
  return (
    <section id="termo-garantia" className="content-section">
      <div className="card mb-3">
        <div className="card-body text-center">
          <h5 className="card-title mb-0">Termo de garantia</h5>
          <p className="card-text d-none">Preencha o formulário para imprimir</p>
        </div>
        <div className="card-body" id="cardCollapse2">
          <div className="card">
            <div className="card-body">
              <form className="col-auto" id="form-termo-garantia">
                <div id="termo-garantia-print">
                  <p className="card-text">Fica expresso que esta garantia contratual é conferida
                    mediante as seguintes condições:
                  </p>
                  <ul className="list-unstyled">
                    <li>
                      <p className="mb-1"><i>
                        Todas as partes, peças e componentes do produto são
                        garantidos contra eventuais vícios de fabricação, que porventura venham a
                        apresentar, pelo prazo de 1 (um) ano – sendo este de 90 (noventa) dias de garantia legal
                        e 9 (nove) meses de garantia contratual –, contado a partir da data da
                        compra do produto pelo Senhor Consumidor, conforme consta na nota fiscal
                        de compra do produto, que é parte integrante deste Termo em todo o território
                        nacional. Esta garantia contratual compreende a troca expressa de produtos que
                        apresentarem vício de fabricação. Caso não seja constatado vício de fabricação,
                        e sim vício(s) proveniente(s) de uso inadequado, o Senhor Consumidor arcará
                        com essas despesas.
                      </i>
                      </p>
                    </li>
                    <li>
                      <p className="mb-1"><i>
                        A instalação do produto deve ser feita de acordo com o Manual do Produto
                        e/ou Guia de Instalação. Caso seu produto necessite a instalação e
                        configuração por um técnico capacitado, procure um profissional idôneo e
                        especializado, sendo que os custos desses serviços não estão inclusos no
                        valor do produto.
                      </i>
                      </p>
                    </li>
                    <li>
                      <p className="mb-1"><i>
                        Constatado o vício, o Senhor Consumidor deverá imediatamente comunicar-se
                        com o Serviço Autorizado mais próximo que conste na relação oferecida pelo
                        fabricante – somente estes estão autorizados a examinar e sanar o defeito
                        durante o prazo de garantia aqui previsto. Se isso não for respeitado, esta
                        garantia perderá sua validade, pois estará caracterizada a violação do
                        produto.
                      </i>
                      </p>
                    </li>
                    <li>
                      <p className="mb-1"><i>
                        Na eventualidade de o Senhor Consumidor solicitar atendimento domiciliar,
                        deverá encaminhar-se ao Serviço Autorizado mais próximo para consulta da
                        taxa de visita técnica. Caso seja constatada a necessidade da retirada do
                        produto, as despesas decorrentes, como as de transporte e segurança de ida
                        e volta do produto, ficam sob a responsabilidade do Senhor Consumidor.
                      </i>
                      </p>
                    </li>
                    <li>
                      <p className="mb-1"><i>
                        A garantia perderá totalmente sua validade na ocorrência de quaisquer das
                        hipóteses a seguir: a) se o vício não for de fabricação, mas sim causado
                        pelo Senhor Consumidor ou por terceiros estranhos ao fabricante; b) se os
                        danos ao produto forem oriundos de acidentes, sinistros, agentes da natureza
                        (raios, inundações, desabamentos, etc.), umidade, tensão na rede elétrica
                        (sobretensão provocada por acidentes ou flutuações excessivas na rede),
                        instalação/uso em desacordo com o manual do usuário ou decorrentes do
                        desgaste natural das partes, peças e componentes; c) se o produto tiver
                        sofrido influência de natureza química, eletromagnética, elétrica ou animal
                        (insetos, etc.); d) se o número de série do produto tiver sido adulterado ou
                        rasurado; e) se o aparelho tiver sido violado.
                      </i>
                      </p>
                    </li>
                    <li>
                      <p className="mb-1"><i>
                        Esta garantia não cobre perda de dados, portanto, recomenda-se, se for o
                        caso do produto, que o Consumidor faça uma cópia de segurança regularmente
                        dos dados que constam no produto.
                      </i>
                      </p>
                    </li>
                    <li>
                      <p className="mb-1"><i>
                        A Intelbras não se responsabiliza pela instalação deste produto, e também
                        por eventuais tentativas de fraudes e/ou sabotagens em seus produtos.
                        Mantenha as atualizações do software e aplicativos utilizados em dia, se
                        for o caso, assim como as proteções de rede necessárias para proteção
                        contra invasões (hackers). O equipamento é garantido contra vícios dentro
                        das suas condições normais de uso, sendo importante que se tenha ciência
                        de que, por ser um equipamento eletrônico, não está livre de fraudes e
                        burlas que possam interferir no seu correto funcionamento.
                      </i>
                      </p>
                    </li>
                    <li>
                      <p className="mb-1"><i>
                        Descarte adequadamente seu produto após vida útil - entregue em pontos de 
                        coleta de produtos eletroeletrônicos, em alguma assistência técnica autorizada 
                        Intelbras ou consulte nosso site www. intelbras.com.br e suporte@intelbras.com.br 
                        ou (48) 2106-0006 ou 0800 7042767 para mais informações.
                      </i>
                      </p>
                    </li>
                  </ul>
                  <ul className="list-unstyled ms-2">
                    <li>
                      <p className="mb-0">Sendo estas as condições deste Termo de Garantia
                        complementar, a Intelbras S/A se reserva o direito de alterar as características
                        gerais, técnicas e estéticas de seus produtos sem aviso prévio.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0">
                        Todas as imagens deste manual são ilustrativas.
                      </p>
                    </li>
                    <li>
                      <p className="mb-0">
                        Produto beneficiado pela Legislação de Informática.
                      </p>
                    </li>
                    <p className="mb-0 text-center text-muted">
                      <small><i>
                        Firefox é uma marca registrada da Mozilla Foundation. UPnP é
                        uma marca registrada da UPnP Implementers Corporation.
                      </i></small>
                    </p>
                    <br />
                    <p className="mb-0">Assinatura do cliente: ________________________</p>
                    <br />
                  </ul>
                </div>
                <div className="d-flex justify-content-center align-items-center d-none">
                  <div className="dropdown">
                    <button className="btn btn-primary" type="button" data-bs-toggle="collapse"
                      data-bs-target="#collapseTermo" aria-expanded="false" aria-controls="collapseTermo">
                      Imprimir termo
                    </button>
                    <div className="collapse" id="collapseTermo">
                      <br />
                      <div className="d-flex flex-wrap mb-3 col-md-12">
                        <label htmlFor="nomeInput" className="form-label text-nowrap">Nome do cliente:</label>
                        <input type="text" id="nomeInput" className="form-control" />
                      </div>
                      <div className="mb-3 col-12">
                        <label htmlFor="nfInput" className="form-label">N° da nota fiscal:</label>
                        <input type="text" id="nfInput" className="form-control" />
                      </div>
                      <div className="mb-3 col-12">
                        <label htmlFor="dataCompraInput" className="form-label">Data da compra:</label>
                        <input type="text" id="dataCompraInput" className="form-control" />
                      </div>
                      <div className="mb-3 col-12">
                        <label htmlFor="modeloInput" className="form-label">Modelo:</label>
                        <input type="text" id="modeloInput" className="form-control" />
                      </div>
                      <div className="mb-3 col-12">
                        <label htmlFor="numSerieInput" className="form-label">N° de série:</label>
                        <input type="text" id="numSerieInput" className="form-control" />
                      </div>
                      <div className="mb-3 col-12">
                        <label htmlFor="revendedorInput" className="form-label">Revendedor:</label>
                        <input type="text" id="revendedorInput" className="form-control" />
                      </div>
                      <div className="d-flex justify-content-center mb-3 col-12">
                        <button className="btn btn-outline-primary col-6" id="export">Enviar</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>

  );
};

export default WarrantyTerm;
